import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=711fd1bf&"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports